<div class="d-flex justify-content-between p-align-center gap-4">
    <div class="sorting-container">
        <p-dropdown *ngIf="isSortingAvailable"
            [options]="sortOptions"
            [(ngModel)]="sortKey"
            placeholder="Sort By Price"
            (onChange)="onSortChange($event)"
            styleClass="mb-2 md:mb-0"></p-dropdown>
    </div>

    <ng-container *ngIf="!hideSearch">
        <div class="search-bar-container mb-2 md:mb-0" [formGroup]="searchForm">
            <span class="p-input-icon-left">
                <i class="ml-3 pi pi-search"></i>

                <input
                    type="text"
                    pInputText
                    formControlName="filter"
                    [placeholder]="l('SearchWithThreeDot')"
                    class="pl-5 form-control search-input"/>

                <button *ngIf="query" (click)="clearInput()" class="clear-btn">
                  <i class="pi pi-times"></i>
                </button>
            </span>
        </div>
    </ng-container>


    <div class="switcher-container mb-2">
        <ng-container *ngIf="isGuided && showAdditionalFilters">
            <div class="kt-checkbox-list ml-4">
                <label for="in_trunk" class="kt-checkbox">
                    <input id="in_trunk" type="checkbox" name="in_trunk" (change)="onShowOnlyInTrunkChange($event)" [(ngModel)]="showOnlyInTrunk">
                    {{"InTrunk" | localize}}
                    <span></span>
                </label>
            </div>
        </ng-container>

        <div class="d-flex">
            <button
                *ngIf="BasePermissionDefinition.Webshop.View.TableView | permission"
                class="switcher-btn"
                [class.active]="isTableView"
                (click)="changeViewMode(ViewMode.TableView)">
                <i class="pi pi-table"></i>
            </button>
            <button
                class="switcher-btn"
                [class.active]="isListView"
                (click)="changeViewMode(ViewMode.ListView)">
                <i class="pi pi-bars"></i>
            </button>
            <button
                class="switcher-btn"
                [class.active]="isTileView"
                (click)="changeViewMode(ViewMode.TileView)">
                <i class="pi pi-th-large"></i>
            </button>
        </div>
    </div>
</div>

